<script setup lang="ts">
import useUserStore from "~/stores/user";
import useEventStore from "~/stores/event";

const { t } = useI18n();
const route = useRoute();
const userStore = useUserStore();
const eventStore = useEventStore();
const appConfig = useRuntimeConfig().public;
const isLoggedIn = computed(() => Boolean(userStore.user));
const userVideos = computed(() => eventStore.userClips.concat(eventStore.userHighlights));
const hasContent = computed(() => userVideos.value.length || eventStore.gameHighlights.length);
const isHighlightsEnabled = appConfig.APP_CUSTOMER.enable_highlights;
const hasPlayerError = computed(() => eventStore.playerState?.error !== null);
const isEventStartingSoon = computed(() => eventStore.isEventStartingSoon);
const isPlaying = computed(() => eventStore.playerState?.playing);
const isClippingModeEnabled = appConfig.APP_CUSTOMER.web_sdk.enable_clipping;

const createClip = () => {
  eventStore.isCreatingClip = true;
  eventStore.tags.isCreatingTag = false;
};
</script>

<template>
  <template v-if="hasContent">
    <div class="h-full max-h-[49vh]">
      <ListVideos
        :title="t('labels.your_clips_highlight')"
        :items="userVideos"
        :loading="eventStore.loading"
        :is-playing="isPlaying"
        hide-on-no-content
      />
      <ListVideos
        v-if="isHighlightsEnabled"
        :title="t('labels.game_highlights')"
        :items="eventStore.gameHighlights"
        :loading="eventStore.loading"
        :is-playing="isPlaying"
        hide-on-no-content
      />
    </div>
  </template>
  <template v-else>
    <div class="w-full text-center py-10 px-4 flex-col items-center flex">
      <IconClip fill="var(--base-icon-color)" :width="32" :height="32" />
      <template v-if="!isClippingModeEnabled">
        <p class="text-body-medium text-secondary py-6">
          {{ t("pages.events.tabs.event_videos.title_enabled_clipping") }}
        </p>
      </template>
      <template v-else-if="isLoggedIn">
        <p class="text-body-medium text-secondary py-6">
          {{ t("pages.events.tabs.event_videos.title_no_clips") }}
        </p>
        <BaseButton name="createTag" class="mb-5" :disabled="hasPlayerError || isEventStartingSoon" type="primary" @click="createClip">
          <div class="flex items-center gap-2">
            <IconClip :width="16" :height="16" fill="#ffffff" />
            <span class="text-button-bold">{{ t("pages.events.tabs.event_videos.create_clip") }}</span>
          </div>
        </BaseButton>
      </template>
      <template v-else>
        <p class="text-body-medium text-secondary py-6">
          {{ t("pages.events.tabs.event_videos.title_no_clips_not_logged_in") }}
        </p>
        <BaseButton
          name="sign-in"
          tag="nuxt-link"
          :title="t('labels.sign_in')"
          :to="{ path: '/auth/login/', query: { redirectUrl: route.fullPath } }"
          class="font-bold text-white"
        >
          {{ t('labels.sign_in') }}
        </BaseButton>
      </template>
    </div>
  </template>
</template>
